export default __webpack_public_path__ + "static/media/3752.273f8320.png";